import Vue from "vue";
import {gaHelper} from "@iamteacherpc/utils/iframe";

/**
 * GA 지표
 */
const gaObjectValidate = (obj) => {
    const arr = Object.keys(obj);
    const validate = ['view_category', 'view_area', 'view_label'];
    return validate.every((value) => arr.indexOf(value) !== -1)
}

const teacherAnalyticsFunc = gaHelper;

Vue.directive('ga-helper', {
    /**
     * @typedef {object} bindingValue
     * @property {string} view_category
     * @property {string} view_area
     * @property {string} view_label
     * @property {string} value
     */

    /**
     * @typedef {object} binding
     * @property {string} name
     * @property {bindingValue} value
     * @property {string} expression
     * @property {string} arg
     * @property {object} modifiers
     */

    /**
     * @param el
     * @param binding
     * @param vnode
     */
    bind: function (el, binding, vnode) {
        const { vueEvent } = binding.modifiers;
        let obj;
        if (typeof binding.value !== 'function') {
            obj = binding.value;
            const result = gaObjectValidate(obj);
            if (!result) {
                console.error('GA object 타입 에러', obj);
                return;
            }
        }

        el.teacherAnalytics = function (event) {
            if (typeof binding.value !== 'function') {
                teacherAnalyticsFunc({...obj});
            } else {
                obj = binding.value(event);
                if (!obj) {
                    return;
                }
                const result = gaObjectValidate(obj);
                if (!result) {
                    console.error('GA 반환 object 타입 에러', obj);
                    return;
                }
                teacherAnalyticsFunc({...obj});
            }
        }

        if (vueEvent) {
            vnode.componentInstance.$on(binding.arg, el.teacherAnalytics);
        } else {
            el.addEventListener(binding.arg, el.teacherAnalytics, { capture: true })
        }
    },

    /**
     * @param el
     * @param binding
     * @param vnode
     */
    unbind: function (el, binding, vnode) {
        const { vueEvent } = binding.modifiers;
        if (vueEvent) {
            vnode.componentInstance.$off(binding.arg, el.teacherAnalytics, { capture: true });
        } else {
            el.removeEventListener(binding.arg, el.teacherAnalytics, { capture: true })
        }
    }
})